import { useFormContext } from "react-hook-form";
import LabeledSelect from "../../../UniversalEditModal/components/LabeledSelect";
import { RegionType } from "../../../../types/EditModal/types";
interface Props {
    regions: RegionType[];
}
export default function RegionSelect({ regions }: Props) {
    const { watch, setValue } = useFormContext();
    const regionName = watch("region_name");

    return (
        <LabeledSelect
            label="Регион"
            options={regions.map((r) => ({ value: r.name, label: r.name }))}
            value={regionName}
            setValue={setValue}
            formName="region_name"
            classes={{
                select_wrapper: "universaleditmodal-right-content-region",
                select_option: "universaleditmodal-right-content-region-option",
                select_value: "universaleditmodal-right-content-region-value",
            }}
        />
    );
}
